module.exports = __webpack_public_path__ + "static/media/cosmopolitan.0ea04a67.jpg";